<template>
  <div>    
    <main-content right-sidebar="true">
      <transition-group
        :css="false"
        @enter="enter"
        @afterEnter="afterEnter"
        @leave="leave"
        class="tag-wrapper"
      >
        <template
          v-for="(livingOption, index) in activeLivingOptions"
          :data-index="index"
          tag="div"
        >
          <tag-basic
            v-if="!livingOption.isVisuallyHidden"
            v-bind="livingOption.marker"
            :key="livingOption._id + '_tag'"
            :pos="{ 
              x: livingOption.marker.x,
              y: livingOption.marker.y
            }"
            :show-sold-label="showSoldLabel(livingOption)"
            :label="{ en: livingOption.displayName || livingOption.label }"
            @click.native="openSubsection(livingOption._id)"
          />

          <polygon-shape
            v-if="livingOption.polygon && livingOption.polygon.points.length && !livingOption.isVisuallyHidden"
            :key="livingOption._id + '_polygon'"
            :polygon="livingOption.polygon"
            :to="polygonUrl(livingOption._id)"
            @click.native="openSubsection(livingOption._id)"
          />
        </template>
      </transition-group>
    </main-content>
  </div>
</template>
<script>
import MainContent from '@/components/MainContent'
import PolygonShape from '@/components/PolygonShape'
import TagBasic from '@/components/TagBasic'
import { bus } from '../main'
import _ from 'lodash'

export default {
  props: ['living-options'],

  components: { MainContent, PolygonShape, TagBasic },

  data () {
    return {
      activeLivingOptions: []
    }
  },

  computed: {
    categoryId () {
      return this.$route.params.categoryId
    },

    pathway () {
      return this.$route.params.pathway
    },

    styleTemplate () {
      return this.$store.state.styleTemplate
    }
  },

  watch: {
    livingOptions (newLivingOptions, oldLivingOptions) {
      if (!_.isEqual(oldLivingOptions, newLivingOptions)) {
        if (oldLivingOptions.length) {
          this.activeLivingOptions = []
        }

        if (newLivingOptions.length) {
          this.$store.commit('addAnimationToQueue', 'LivingOptionTags')
        }
      }
    }
  },

  mounted () {
    bus.$on('animateLivingOptionTags', () => {
      console.log('firing animateLivingOptionTags')
      if (!_.isEqual(this.activeLivingOptions, this.livingOptions)) {
        console.log(this.activeLivingOptions)
        this.activeLivingOptions = this.livingOptions
        console.log(this.activeLivingOptions)
      } else {
        bus.$emit('finishedAnimation')
      }
    })
  },

  methods: {
    isSoldOut (livingOption) {
      return livingOption.availableProperties === 0
    },
    
    showSoldLabel (livingOption) {
      return this.styleTemplate['general']['show-sold-label'] && this.isSoldOut(livingOption)
    },

    openSubsection (id) {
      const toLivingOption = this.$store.getters['property/livingOptions'].find(livingOption => livingOption._id === id)

      const isSoldOut = toLivingOption.availableProperties === 0
      const canInteract = this.styleTemplate['general']['can-interact-sold-livingoptions']

      if (isSoldOut && !canInteract) {
        return
      }

      if (toLivingOption.subsections.length === 1) {
        this.$router.push(`/category/${this.categoryId}/live/${this.pathway}/${id}/subsection/${toLivingOption.subsections[0]._id}?activeSubsectionId=${toLivingOption.subsections[0]._id}`)
      } else {
        this.$router.push(`/category/${this.categoryId}/live/${this.pathway}/${id}`)
      }
    },

    polygonUrl (id) {
      const toLivingOption = this.$store.getters['property/livingOptions'].find(livingOption => livingOption._id === id)

      if (toLivingOption.subsections.length === 1) {
        return `/category/${this.categoryId}/live/${this.pathway}/${id}/subsection/${toLivingOption.subsections[0]._id}?activeSubsectionId=${toLivingOption.subsections[0]._id}`
      } else {
        return `/category/${this.categoryId}/live/${this.pathway}/${id}`
      }
    },

    enter (el, done) {
      const tagType = el.getAttribute('data-type')

      this.animationSpeed = 100

      if (tagType === 'basic') {
        this.animationSpeed = 50
      }

      setTimeout(() => {
        el.classList.add('enter')
        done()
      }, (parseInt(this.delayIndex++) + 1) * this.animationSpeed)
    },

    afterEnter (el) {
      if (parseInt(el.dataset.index) + 1 === this.activeLivingOptions.length) {
        bus.$emit('finishedAnimation')
        this.delayIndex = 0
      }
    },

    leave (el) {
      el.classList.add('leave')
      el.classList.remove('enter')
    },
  }
}
</script>
<style lang="scss" scoped>
.tag-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;

  .layout-switched & {
    top: 10rem;
  }
}
</style>
